// Complete menu data for INSTA CAFE

export const menuCategories = [
  {
    id: 'hot',
    name: 'Hot Section',
    icon: '☕',
    items: [
      { name: 'Tea', price: 12, veg: true, image: 'https://images.unsplash.com/photo-1610478506025-8110cc8f1986?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHx0ZWElMjBjdXB8ZW58MHx8fHwxNzcxMDY4NTIwfDA&ixlib=rb-4.1.0&q=85' },
      { name: 'Coffee', price: 15, veg: true, image: 'https://images.unsplash.com/photo-1577968897966-3d4325b36b61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHx0ZWElMjBjdXB8ZW58MHx8fHwxNzcxMDY4NTIwfDA&ixlib=rb-4.1.0&q=85' },
      { name: 'Milk', price: 15, veg: true },
      { name: 'Ginger Tea', price: 14, veg: true },
      { name: 'Lemon Tea', price: 15, veg: true },
      { name: 'Green Tea', price: 15, veg: true },
      { name: 'Boost', price: 20, veg: true },
      { name: 'Horlicks', price: 20, veg: true },
      { name: 'Badam Milk', price: 20, veg: true },
      { name: 'Complan', price: 20, veg: true }
    ]
  },
  {
    id: 'juice',
    name: 'Fresh Juice',
    icon: '🧃',
    items: [
      { name: 'Lemon Juice', price: 25, veg: true },
      { name: 'Lemon Mint', price: 30, veg: true },
      { name: 'Sarbath', price: 25, veg: true },
      { name: 'Soda Sarbath', price: 30, veg: true },
      { name: 'Watermelon', price: 50, veg: true },
      { name: 'Pineapple', price: 60, veg: true },
      { name: 'Mosambi', price: 70, veg: true },
      { name: 'Orange', price: 70, veg: true },
      { name: 'Muskmelon', price: 80, veg: true },
      { name: 'Apple', price: 90, veg: true },
      { name: 'Pomegranate', price: 100, veg: true }
    ]
  },
  {
    id: 'milkshakes',
    name: 'Milkshakes',
    icon: '🥤',
    items: [
      { name: 'Rose Milk', price: 40, veg: true },
      { name: 'Badam Milk', price: 50, veg: true },
      { name: 'Sharjah', price: 60, veg: true },
      { name: 'Butterscotch', price: 60, veg: true },
      { name: 'Chocolate', price: 60, veg: true, featured: true, image: 'https://images.unsplash.com/photo-1595434091143-b375ced5fe5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHx0ZWElMjBjdXB8ZW58MHx8fHwxNzcxMDY4NTIwfDA&ixlib=rb-4.1.0&q=85' },
      { name: 'Vanilla', price: 80, veg: true },
      { name: 'Green Apple', price: 80, veg: true },
      { name: 'Kiwi', price: 80, veg: true, featured: true },
      { name: 'Strawberry', price: 80, veg: true },
      { name: 'Blackcurrant', price: 80, veg: true },
      { name: 'Litchi', price: 80, veg: true },
      { name: 'Orange', price: 80, veg: true },
      { name: 'Mango', price: 80, veg: true },
      { name: 'Pineapple', price: 80, veg: true }
    ]
  },
  {
    id: 'mojito',
    name: 'Mojito',
    icon: '🍹',
    items: [
      { name: 'Virgin', price: 60, veg: true },
      { name: 'Watermelon', price: 70, veg: true },
      { name: 'Bubble Gum', price: 70, veg: true },
      { name: 'Muskmelon', price: 70, veg: true },
      { name: 'Green Mint', price: 70, veg: true },
      { name: 'Green Apple', price: 70, veg: true },
      { name: 'Kiwi', price: 70, veg: true },
      { name: 'Gulab Gulkand', price: 80, veg: true },
      { name: 'Passion Fruit', price: 80, veg: true },
      { name: 'Blue Curacao Mojito', price: 80, veg: true, featured: true, image: 'https://images.unsplash.com/photo-1653542772393-71ffa417b1c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2ppdG98ZW58MHx8fHwxNzcxMDY4NTI5fDA&ixlib=rb-4.1.0&q=85' }
    ]
  },
  {
    id: 'falooda',
    name: 'Falooda',
    icon: '🍨',
    items: [
      { name: 'Classic', price: 70, veg: true },
      { name: 'Chocolate', price: 90, veg: true },
      { name: 'Saudi Arabia', price: 100, veg: true },
      { name: 'Royal Falooda', price: 120, veg: true, featured: true }
    ]
  },
  {
    id: 'snacks',
    name: 'Snacks',
    icon: '🍿',
    items: [
      { name: 'Vada', price: 10, veg: true },
      { name: 'Samosa', price: 15, veg: true },
      { name: 'Maggi Samosa', price: 18, veg: true },
      { name: 'Egg Samosa', price: 20, veg: false },
      { name: 'Chicken Samosa', price: 25, veg: false }
    ]
  },
  {
    id: 'puffs',
    name: 'Puffs & Buns',
    icon: '🥐',
    items: [
      { name: 'Egg Puff', price: 20, veg: false },
      { name: 'Chicken Puff', price: 25, veg: false },
      { name: 'Chicken Roll', price: 25, veg: false },
      { name: 'Mayo Bun', price: 30, veg: true }
    ]
  },
  {
    id: 'frozen-veg',
    name: 'Frozen Items Veg',
    icon: '🍟',
    items: [
      { name: 'French Fries Medium', price: 60, veg: true, featured: true, image: 'https://images.unsplash.com/photo-1630384060421-cb20d0e0649d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxmcmllc3xlbnwwfHx8fDE3NzEwNjg1Mzd8MA&ixlib=rb-4.1.0&q=85' },
      { name: 'French Fries Large', price: 80, veg: true }
    ]
  },
  {
    id: 'momos',
    name: 'Momos',
    icon: '🥟',
    items: [
      { name: 'Veg Momos', price: 60, veg: true },
      { name: 'Paneer Momos', price: 80, veg: true },
      { name: 'Corn Momos', price: 80, veg: true }
    ]
  },
  {
    id: 'frozen-nonveg',
    name: 'Frozen Items Non-Veg',
    icon: '🍗',
    items: [
      { name: 'Bread Omelet', price: 50, veg: false },
      { name: 'Cheese Bread Omelet', price: 60, veg: false },
      { name: 'Chicken Bread Omelet', price: 70, veg: false },
      { name: 'Chicken Nuggets', price: 80, veg: false, featured: true, image: 'https://images.unsplash.com/photo-1562967914-608f82629710?w=800' },
      { name: "Chicken Pop'z", price: 100, veg: false },
      { name: 'Chicken Momos', price: 80, veg: false },
      { name: 'Chicken Snacker', price: 80, veg: false },
      { name: 'Fish Finger', price: 80, veg: false },
      { name: 'Chicken Fingers', price: 100, veg: false },
      { name: 'Crab Claw', price: 100, veg: false }
    ]
  },
  {
    id: 'shawarma',
    name: 'Shawarma',
    icon: '🌯',
    items: [
      { name: 'Cone Shawarma', price: 40, veg: false },
      { name: 'Classic Shawarma', price: 80, veg: false, featured: true, bestseller: true, image: 'https://images.unsplash.com/photo-1662116765994-1e4200c43589?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzaGF3YXJtYXxlbnwwfHx8fDE3NzEwNjg1MTZ8MA&ixlib=rb-4.1.0&q=85' },
      { name: 'Full Meat', price: 100, veg: false },
      { name: 'Peri Peri Shawarma', price: 100, veg: false, bestseller: true, image: 'https://images.unsplash.com/photo-1719282431565-3b30bb7d2658?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxzaGF3YXJtYXxlbnwwfHx8fDE3NzEwNjg1MTZ8MA&ixlib=rb-4.1.0&q=85' },
      { name: 'Schezwan', price: 100, veg: false },
      { name: 'Peri Peri Full Meat', price: 120, veg: false },
      { name: 'Schezwan Full Meat', price: 120, veg: false },
      { name: 'Peri Peri Plate', price: 140, veg: false },
      { name: 'Schezwan Plate', price: 140, veg: false }
    ]
  },
  {
    id: 'combo',
    name: 'Combo Offer',
    icon: '🎁',
    items: [
      { name: 'Lime + Bread Omelet', price: 60, veg: false },
      { name: 'Bread Omelet + French Fries + Lime', price: 100, veg: false }
    ]
  }
];

// Featured products for homepage
export const featuredProducts = menuCategories
  .flatMap(cat => cat.items)
  .filter(item => item.featured)
  .slice(0, 8);

// Bestseller products
export const bestsellerProducts = menuCategories
  .flatMap(cat => cat.items)
  .filter(item => item.bestseller);

// Get all items with images
export const productsWithImages = menuCategories
  .flatMap(cat => cat.items)
  .filter(item => item.image);